import React from 'react';
import { Col, Container, Image, Row } from 'react-bootstrap';
import QueryForm from '../../../Pages/Static/queryForm';
// import AlorBanner from '../../../../Assets/images/benchmark.png';
// import AlorBannerMobile from '../../../../Assets/images/benchmark.png';
import { isMobileOnly } from 'react-device-detect';
import { Helmet } from 'react-helmet';

const Benchmark = () => {
  return (
    <>
    <Helmet>
    <script src="https://www.benchmarkrings.com/iframe/load/PcEcdfMqilOnSvlKIQToHg" target="_blank" title="null" rel="noopener"></script>
    </Helmet>
      <div className="watch_repaire_services_page">
        <Container fluid>
          <Row>
            <Col sm={12} md={12} lg={12} className="p-0">
              <div><img src={require("../../../../Assets/images/Benchmark.png")} className="img-fluid"  alt='Oris'/></div>
            </Col>
          </Row>
          <div className="text-center pt-5">
            <Row className="justify-content-center">
              <Col lg={8}>
                <h3 className="text-center text-uppercase">Benchmark</h3>
                <p>Explore the epitome of fine craftsmanship with Benchmark Jewelry. Melding tradition and innovation, each piece reflects timeless beauty and enduring quality. Elevate your style with the elegance and precision of Benchmark, where every creation is a symbol of refined sophistication.</p>
              </Col>
            </Row>

            <div id="benchmark-rings-embed"></div>
          </div>
        </Container>
        {/* <QueryForm /> */}
      </div>
    </>
  );
};

export default Benchmark;
